import React, { useContext, useEffect, useState } from "react";
import CustomTab from "../../components/800/CustomTab";
// import axios from "axios";
// import config from "../../config";
// import { ResearchContext } from "../../context/ResearchContext";

//pages import
import ResearchList from "./researchList";
import ResearchApproval from './researchApproval'
import ResearchArchiveExpired from './researchArchiveExpired'
import { Badge, Button } from "@mui/material";
import { Link } from "react-router-dom";
import ResearchExtensionRequest from "./researchExtensionRequest";
import ResearchSettings from "../../components/800/ResearchSettings";


const ResearchManagementPage = () => {
  const [approvalBadgeCounter, setApprovalBadgeCounter] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      // const approvalNumber = await axios(`${config.apiBase}/research/approval/number`)
      // setApprovalBadgeCounter(approvalNumber.data)
    }

    fetchData()
  }, [])

  const tabLabels = [
    "Research Requests",
    "Extension Requests",
    "Active Reseaches",
    "Archived/Expired",
  ];
  const tabElements = [
    <ResearchApproval />,
    <ResearchExtensionRequest />,
    <ResearchList />,
    <ResearchArchiveExpired />,
  ];
  // console.log('context: ', useContext(ResearchContext))
  return (
    <>
      {/* <Button><Link to='research'>Edit</Link></Button> */}
      <CustomTab tabElements={tabElements} tabLabels={tabLabels} />
    </>
  );
};

export default ResearchManagementPage;
